import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthLayout } from './layouts/AuthLayout';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { ForgotPassword } from './pages/ForgotPassword';
import { ResetPassword } from './pages/ResetPassword';
import { VerifyEmail } from './pages/VerifyEmail';
import { Home } from './pages/Home';
import { Game } from './pages/Game';
import { ProtectedRoute } from './components/ProtectedRoute';
import { useVersionCheck } from './hooks/useVersionCheck.js';

function VersionCheck() {
  useVersionCheck();
  return null;
}

export function App() {
  return (
    <BrowserRouter>
      <VersionCheck />
      <Routes>
        <Route path="/game" element={<ProtectedRoute><Game /></ProtectedRoute>} />
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
